<template>
  <div class="monitor-grid">
    <div
      class="monitor-item"
      v-for="item in monitors"
      :key="item.name"
      role="button"
      tabindex="0"
      @click="openVideo(item)"
      @keydown.enter.prevent="openVideo(item)"
      @keydown.space.prevent="openVideo(item)"
    >
      <div class="monitor-frame">
        <img :src="item.img" :alt="item.name" />
        <div class="play-layer">
          <span class="play-button"></span>
        </div>
      </div>
      <div class="monitor-name">{{ item.name }}</div>
    </div>
  </div>
  <popBg
    v-if="popShow && currentVideo"
    :title="currentVideo.name"
    :code="currentVideo.code"
    :popShow="popShow"
    @hiddlen="closeVideo"
  >
    <div class="monitor-pop-video">
      <iframe
        :src="currentIframeSrc"
        width="100%"
        height="100%"
        allowfullscreen
      ></iframe>
    </div>
  </popBg>
</template>

<script setup>
import { computed, ref } from "vue";
import popBg from "@/components/popBg.vue";

const ysIframePrefix = "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com";

const monitors = [
  {
    name: "玫瑰大棚全景",
    img: require("@/assets/img/left_video1.png"),
    code: "FC4283860",
    iframeSrc: `${ysIframePrefix}/FC4283860/1.live&autoplay=1&accessToken=`,
  },
  {
    name: "大田监测",
    img: require("@/assets/img/left_video2.png"),
    code: "E53817475",
    iframeSrc: `${ysIframePrefix}/E53817475/1.live&autoplay=1&accessToken=`,
  },
  {
    name: "大田地块监控",
    img: require("@/assets/img/left_video3.png"),
    code: "AZ8538489",
    iframeSrc: `${ysIframePrefix}/AZ8538489/1.live&autoplay=1&accessToken=`,
  },
  {
    name: "畜禽养殖基地",
    img: require("@/assets/img/left_video4.png"),
    code: "FB2502253",
    iframeSrc: `${ysIframePrefix}/FB2502253/1.live&autoplay=1&accessToken=`,
  },
];

const popShow = ref(false);
const currentVideo = ref(null);
const accessToken = ref("");

const currentIframeSrc = computed(() => {
  if (!currentVideo.value) return "";
  return `${currentVideo.value.iframeSrc}${accessToken.value}`;
});

function openVideo(video) {
  currentVideo.value = video;
  accessToken.value = localStorage.getItem("AccessToken") || "";
  popShow.value = true;
}

function closeVideo() {
  popShow.value = false;
  currentVideo.value = null;
}
</script>

<style lang="less" scoped>
.monitor-grid {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 30px 46px;
  padding: 20px 0 22px;
  box-sizing: border-box;
  overflow: hidden;
}

.monitor-item {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.monitor-frame {
  flex: 1;
  min-height: 0;
  padding: 10px;
  background: url("~@/assets/img/gbzntyj/gaungai/spk.png") no-repeat center center;
  background-size: 100% 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.play-layer {
  position: absolute;
  inset: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.08), rgba(0, 22, 24, 0.34));
  pointer-events: none;
}

.play-button {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
  border: 2px solid rgba(128, 255, 244, 0.86);
  background: radial-gradient(circle, rgba(0, 188, 179, 0.72), rgba(0, 63, 68, 0.82));
  box-shadow:
    0 0 22px rgba(47, 255, 239, 0.45),
    inset 0 0 18px rgba(255, 255, 255, 0.18);
}

.play-button::after {
  content: "";
  position: absolute;
  left: 38px;
  top: 28px;
  width: 0;
  height: 0;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  border-left: 26px solid #ffffff;
  filter: drop-shadow(0 0 8px rgba(116, 255, 244, 0.9));
}

.monitor-item:hover .play-button {
  transform: scale(1.08);
  box-shadow:
    0 0 30px rgba(47, 255, 239, 0.68),
    inset 0 0 22px rgba(255, 255, 255, 0.24);
}

.monitor-name {
  height: 48px;
  line-height: 48px;
  color: #00d6ff;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
}

.monitor-pop-video {
  width: 100%;
  height: 100%;

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
